export const release = 'myhealthmoney@b544c440';